import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const packages = [
  { name: 'Starter', price: '$499/mo', features: ['SEO Audit', 'Basic Social Media', 'Monthly Reporting'] },
  { name: 'Growth', price: '$999/mo', features: ['Everything in Starter', 'Content Marketing', 'PPC Management', 'Bi-weekly Reporting'] },
  { name: 'Pro', price: '$1999/mo', features: ['Everything in Growth', 'Advanced SEO', 'Conversion Optimization', 'Weekly Reporting'] },
];

const Pricing = () => (
  <section className="min-h-screen bg-[#0f1a29] py-20 px-4 flex flex-col items-center justify-center">
    <div className="max-w-4xl w-full bg-white rounded-2xl shadow-2xl p-10 relative z-10">
      <motion.h1
        className="text-4xl font-bold text-brand-blue mb-6 text-center"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: 'easeOut' }}
      >
        Pricing & Packages
      </motion.h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {packages.map((p, i) => (
          <motion.div
            key={i}
            className="bg-blue-50 rounded-lg p-6 shadow flex flex-col items-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: i * 0.2, ease: 'easeOut' }}
          >
            <h2 className="text-2xl font-bold text-brand-blue mb-2">{p.name}</h2>
            <p className="text-3xl font-bold text-gray-900 mb-4">{p.price}</p>
            <ul className="list-disc pl-4 mb-4 text-gray-700 text-left">
              {p.features.map((f, j) => <li key={j}>{f}</li>)}
            </ul>
            <button className="mt-auto px-6 py-2 bg-brand-blue text-white rounded-lg shadow hover:bg-blue-700 transition font-semibold">Get Started</button>
          </motion.div>
        ))}
      </div>
      <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
        <Link to="/" className="px-6 py-3 bg-brand-blue text-white rounded-lg shadow hover:bg-blue-700 transition font-semibold text-center">Back to Home</Link>
        <Link to="#contact" onClick={e => { e.preventDefault(); const section = document.getElementById('contact'); if (section) section.scrollIntoView({ behavior: 'smooth' }); }} className="px-6 py-3 bg-blue-100 text-brand-blue rounded-lg shadow hover:bg-blue-200 transition font-semibold text-center">Contact Us</Link>
      </div>
    </div>
  </section>
);

export default Pricing; 